import 'jquery/dist/jquery.min';
import 'jquery-validation/dist/jquery.validate.min';
import 'jquery-validation/dist/additional-methods.min';
import { Constants } from "../ENVIROMENT_VARIABLES";
import jwt_decode from "jwt-decode";

const next = document.querySelector("#next");
const prev = document.querySelector("#prev");
const progress = document.querySelector(".progress");
const circles = document.querySelectorAll(".circle");
const step1 = document.querySelector('#step1');
const step2 = document.querySelector('#step2');
const step3 = document.querySelector('#step3');
const step4 = document.querySelector('#step4');
const step5 = document.querySelector('#step5');
const nextBtn = document.querySelector('#next');
const confirmBtn = document.querySelector('#confirm');
let counter = 1;
var totalPrice=0;
var testList = JSON.parse(localStorage.getItem('testList'));
var TP_Token=JSON.parse(sessionStorage.getItem('TP_Token'));
var TPP_Token = JSON.parse(sessionStorage.getItem('TPP_Token'));
var IsAuthenticated=TPP_Token ? true :false ;
var decoded = jwt_decode(TPP_Token.Token);
var TPP_Mobile=decoded.mobileNumber;
var languageKey = getLanguageFromLocalStorage();
const originUrl = location.origin;
var holder;
var selectedTime = [];
var selectedBranchId;
var branchId;
var getSlotForm;
var defaultDate ;
var dateformatter;
var deafultendSlot;
var dateslot;
var orderData;
$("#loading-overlay").show();
    
// API CALLING FOR BRANCH LIST
$.ajax({
type: "POST",
url:`${Constants.BASE_URL}thirdParty/getBranches.srvc?method=POST`,
headers: {
    "Content-Type":"application/json",
     Accept: "application/json",
    'Data-Type': 'json',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': '*',
    'Access-Control-Allow-Headers': 'Content-Type , Authorization',
    'Access-Control-Allow-Credentials': 'true',
    'Authorization': `Bearer ${TP_Token.Token}`
},
success: function (data) {

  $("#loading-overlay").hide();

  for(let i=0; i<data.length; i++){
    let locationArray=(data[i].latitudeLongitude).split(",");
    let latitude=locationArray[0];
    let longitude=locationArray[1];
    $('#branches-containers').append($(`
    <div class="branch card-container col-12 col-lg-4" data-branchId="${data[i].rid}">
    <div class="card">
      <div class="card-body d-flex flex-row-reverse">
        <div class="selected-branch">
          <i class="fas fa-check"></i>
        </div>
        <div class="text-container">
          <h5 class="card-title">${data[i].name[languageKey]}</h5>
          <p>Al-Ryadh</p>
          <div class="details-group">
            <a href="https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}"
              class="view-map" target="_blank">View Map</a>
          </div>
          <div class="details-group d-flex align-items-baseline">
            <h6 class="card-subtitle me-1">Phone: </h6>
            <p class="card-text"><a href="tel:${data[i].mobileNo}">${data[i].mobileNo}</a></p>
          </div>
          <div class="details-group d-flex align-items-baseline">
            <h6 class="card-subtitle me-1">FaxNo: </h6>
            <p class="card-text"><a href="tel:${data[i].faxNo}">${data[i].faxNo}</a></p>
          </div>
          <div class="details-group">
            <h6 class="card-subtitle">Opening Time</h6>
            <p class="card-text">Sunday to Friday ${data[i].workingHours}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
    `,
    ));
   }
   // Branches in step 2
   const branches_form = $('#branches_form');
   const branches_map = $('#map');
   const branches_list = $('#step2 .branches-wrapper .branch');
   $(function () {
   
       // EVENT HANDLER
       // On change city selection
       branches_form.find('select').on('change', (e) => {
           e.preventDefault();
           const selectedCityId = $(e.currentTarget).val();
           if (selectedCityId !== '0') {
               branches_list.removeClass('active');
               for (let i = 0; i < branches_list.length; i++) {
                   let currentBranchCity = branches_list.eq(i).attr('data-cityId');
                   currentBranchCity === selectedCityId && branches_list.eq(i).addClass('active');
               }
           } else {
               branches_list.addClass('active');
           }

           activeFirstBranchOnMap();
       });

       //EVENT HANDLER
       // On click branch view map button
       branches_list.find('.view-location-btn').on('click', (e) => {
           const location = $(e.currentTarget).attr('data-location');
           const map = $(e.currentTarget).attr('data-map');
           const card = $(e.currentTarget).parents('.card');
           branches_map.find('iframe').attr('src', map);
           branches_map.find('.open-map-btn').attr('href', location);
           branches_map.addClass('active');
           branches_list.find('.card').removeClass('active');
           card.addClass('active');
           window.scrollTo({
               top: document.querySelector('#map').offsetTop,
               behavior: "smooth"
           })
       });

       branches_list.find('.card-body').on('click', (e) => {
           const location = $(e.currentTarget).attr('data-location');
           const map = $(e.currentTarget).attr('data-map');
           const card = $(e.currentTarget).parents('.card');
           const selected_branch = $(e.currentTarget).children('.selected-branch');
           branches_map.find('iframe').attr('src', map);
           branches_map.find('.open-map-btn').attr('href', location);
           branches_map.addClass('active');
           branches_list.find('.card').removeClass('active');
           branches_list.find('.selected-branch').removeClass('active');
           card.addClass('active');
           selected_branch.addClass('active');
       });


       // Activate the first branch map
       function activeFirstBranchOnMap() {
           $('#step2 .branch.active').eq(0).find('.card').addClass('active');
           $('#step2 .branch.active').eq(0).find('.selected-branch').addClass('active');
           $('#step2 .branch.active').eq(0).find('.view-location-btn').trigger('click');
       }

       // ON PAGE LOAD EVENT
       const selectedCityId = branches_form.find('select').val();
       if (selectedCityId !== '0') {
           for (let i = 0; i < branches_list.length; i++) {
               let currentBranchCity = branches_list.eq(i).attr('data-cityId');
               currentBranchCity === selectedCityId && branches_list.eq(i).addClass('active');
           }
       } else {
           branches_list.addClass('active');
       }
       activeFirstBranchOnMap();

   });
},

});


function getSlots(holder){
   // API CALLING FOR Slots
 getSlotForm={
    branchId: selectedBranchId ,
    startDate: holder
}
$.ajax({
    url:`${Constants.BASE_URL}thirdParty/getSlots.srvc?method=POST`,
    method: "POST",
        headers: {
          "Content-Type":"application/json",
          Accept: "application/json",
        },
        data:JSON.stringify(getSlotForm),
        beforeSend: function (xhr) {
             $("#loading-overlay").show();
          xhr.setRequestHeader("Authorization", `Bearer ${TPP_Token.Token}`);
          
        },
    success: function (data) {
      $("#loading-overlay").hide();
      
    $.each(data, function (i, p) {
        const timeSlot = data[i].startTime;
        $('#date-dropdown').append($(`<li><a class="dropdown-item" data-slotid="${data[i].rid}" data-date="${timeSlot}">
            ${timeSlot.split('T')[0]} | ${timeSlot.split('T')[1].substring(0, 5)}
        </a></li>`));
    
        // Event handler for selecting a date
        $(document).on('click', `.dropdown-item`, function() {
            const timeSlot = $(this).text();
            const slotId = $(this).attr('data-slotid');
            const actualDate = $(this).attr('data-date');
            $('#choose-time').text(timeSlot);
            orderBranchDetail.endTime = actualDate;
            orderHomeVisitDetail.slotId = slotId;
            localStorage.setItem('orderBranchDetail', JSON.stringify(orderBranchDetail));
            localStorage.setItem('orderHomeVisitDetail', JSON.stringify(orderHomeVisitDetail));

          });
          
    });
    },
    
    });
}
// API CALLING FOR Family Member

function getFamilyMember(){
    $("#loading-overlay").show();

    $.ajax({
        type: "POST",
        url:`${Constants.BASE_URL}thirdParty/getPatients.srvc?method=POST`,
        headers: {
            'Accept': 'application/json',
            'Content-Type':'application/json',
            'Data-Type': 'json',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods': '*',
            'Access-Control-Allow-Headers': 'Content-Type , Authorization',
            'Access-Control-Allow-Credentials': 'true',
            'Authorization': `Bearer ${TPP_Token.Token}`
        },
        success: function (data) {
          $("#loading-overlay").hide();
        
          for(let i=0; i<data.length; i++){
            if(data[i].isMobileOwner){
                $('#myself-select').append($(`
                <div id="myself-id" class="col-md-4 family-member-id" data-patientid="${data[i].rid}">
                    <div class="user active">
                        <div class="selected-user active">
                        <i class="fas fa-check"></i>
                        </div>
                        <div id="personal-id">
                        <h6>${data[i].fullName[languageKey]}</h6>
                        <p>${data[i].gender.description[languageKey]}</p>
                        <p>${data[i].address[languageKey]}</p>
                        <p>${data[i].mobileNo}</p>
                        <p>${data[i].email}</p>
                        <p>${data[i].isMobileOwner ? 'Account Owner' :''}</p>
                        </div>
                    </div>
                </div>
                `
                ));
            }
            else{
                $('#user-select').append($(`
                <div class="col-md-4 family-member-id" data-patientid="${data[i].rid}">
                <div class="user">
                  <div class="selected-user">
                    <i class="fas fa-check"></i>
                  </div>
                  <div >
                    <h6>${data[i].fullName[languageKey]}</h6>
                    <p>${data[i].gender.description[languageKey]}</p>
                    <p>${data[i].address[languageKey]}</p>
                    <p>${data[i].mobileNo}</p>
                    <p>${data[i].email}</p>
                    <p>${data[i].isMobileOwner ? 'Account Owner' :''}</p>
                  </div>
                </div>
              </div>
               `
               ));
               getSelectedUser();
            }
          }
        },
        
        });
}
getFamilyMember();

next.addEventListener("click", () => {
    if(testList && testList.length > 0){
        counter++;
        update();
        displaySteps(counter);
        $("#next").prop( "disabled", false );

    }
    else{
        $("#next").prop( "disabled", true );
    }



});

prev.addEventListener("click", () => {
    counter--;
    update();
    displaySteps(counter);
});

function update() {
    circles.forEach((circle, index) => {
        if (index < counter) {
            circle.classList.add("active");
        } else {
            circle.classList.remove("active");
        }
    });

    if (counter === 1) {
        prev.disabled = true;
        prev.hidden = true;
    } else if (counter === circles.length) {
        next.disabled = true;
    } else {
        prev.disabled = false;
        prev.hidden = false;
        next.disabled = false;
    }
}

// Display steps
function displaySteps(counter) {
    if (counter == 1) {
        step1.style.display = 'block';
        step2.style.display = 'none';
        step3.style.display = 'none';
        step4.style.display = 'none';
        step5.style.display = 'none';
        nextBtn.style.display = 'block';
        confirmBtn.style.display = 'none';
        $("#next").prop( "disabled", false ); 


    } else if (counter == 2) {
        step1.style.display = 'none';
        step2.style.display = 'block';
        step3.style.display = 'none';
        step4.style.display = 'none';
        step5.style.display = 'none';
        nextBtn.style.display = 'block';
        confirmBtn.style.display = 'none';
   
    // if(counter == 2 && ('#home-visit').checked){
    //     //console.log(counter == 2 && ('#home-visit').checked)
    //         nextBtn.click(function ()  {

    //             $.each($(this).closest('form').find('input[type="text"]'), function () {
    //                 if ($(this).val() == '') 
    //                     patientAddressValidate()
    //             });
    //         })
    // }


    } else if (counter == 3) {
        step1.style.display = 'none';
        step2.style.display = 'none';
        step3.style.display = 'block';
        step4.style.display = 'none';
        step5.style.display = 'none';
        nextBtn.style.display = 'block';
        confirmBtn.style.display = 'none';


    } else if (counter == 4) {
        step1.style.display = 'none';
        step2.style.display = 'none';
        step3.style.display = 'none';
        step4.style.display = 'block';
        step5.style.display = 'none';
        nextBtn.style.display = 'block';
        confirmBtn.style.display = 'none';
        orderData=JSON.stringify(
            {
                InvoiceAmount: 0,
                CurrencyIso: 'KWD'
            }
        );
        for(let i=0; i<13; i++){
            $('#payment-container').append(`
            <img data-PaymentMethodId="3" class="img-fluid" src="https://demo.myfatoorah.com/imgs/payment-methods/np.png">
            `)

        }
        $('.payment-container img').on('click', function() {
            $('.payment-container img').not(this).removeClass('selected');
            $(this).toggleClass('selected');
            var selectedPaymentMethodId = $(this).data('paymentmethodid');
            console.log(selectedPaymentMethodId);

        });
        $.ajax({
            type: 'POST',
            url: 'log.php',
            data: JSON.stringify(orderData),
            contentType: 'application/json', // Set the content type to JSON
            success: function(response) {
                // Handle the response data
                console.log(response);
                var PaymentMethods=response.Data.PaymentMethods
                for(let i=0; i<PaymentMethods; i++){
                    $('#payment-container').append(`
                        <img  class="img-fluid" data-PaymentMethodId=${PaymentMethods[i].PaymentMethodId}  src="${PaymentMethods[i].ImageUrl}">
                    `)
                }
                $('.payment-container img').on('click', function() {
                    $('.payment-container img').not(this).removeClass('selected');
                    $(this).toggleClass('selected');
                    var selectedPaymentMethodId = $(this).data('paymentmethodid');
                    console.log(selectedPaymentMethodId);
        
                });
            },
            error: function(xhr, status, error) {
                // Handle the error
                console.error(error);
            }
        });
        
        


    } else if (counter == 5) {
        step1.style.display = 'none';
        step2.style.display = 'none';
        step3.style.display = 'none';
        step4.style.display = 'none';
        step5.style.display = 'block';
        nextBtn.style.display = 'none';
        confirmBtn.style.display = 'block';
    }
}
// document.getElementById("sucessOrder").style.display = "none";

$(document).ready(function () {
// Confirm button action
confirmBtn.addEventListener("click", function () {
    CreateOrder(IsAuthenticated)

    // document.getElementById("sucessOrder").style.display = "flex";

    // $('sucessOrder').addClass('d-flex')
})
})

// ----------------------------------------------------------------------------------------------------------------
 // validate on address field
function patientAddressValidate(){
    const patient_form = $('#patient-form');
    patient_form.validate({
        errorClass: "invalid",
        validClass: "valid",
        rules: { 
            PatientAddress:{required: true, minlength: 6 , 
            }
         },
         messages:{
            PatientAddress:{
                required: "Please enter your Address",
                minlength: "Please enter Full Address" , 

            },
         },
         onfocusout: function(element) {
            this.element(element); // triggers validation
        },
        onkeyup: function(element, event) {
            this.element(element); // triggers validation
        },
        errorElement: "em",
        errorPlacement: function ( error, element ) {
            // Add the `help-block` class to the error element
            error.addClass( "alert alert-danger d-flex align-items-center mt-2" );
   
            // Add `has-feedback` class to the parent div.form-group
            // in order to add icons to inputs
            element.parents( ".input-field" ).addClass( "is-invalid" );
   
            if ( element.prop( "type" ) === "checkbox" ) {
                error.insertAfter( element.parent( "label" ) );
            } else {
                error.insertAfter( element );
            }
        },
        success: function ( label, element ) {
           // //console.log('success');
           //hide error alert
           $( element ).addClass( "is-valid" ).removeClass( "-invalid" );
           $( element ).siblings( 'em' ).removeClass( "alert alert-danger d-flex align-items-center mt-2" );
        },
        highlight: function ( element, errorClass, validClass ) {
            $( element ).addClass( "is-invalid" ).removeClass( "is-valid" );
            // $( element ).next( "span" ).addClass( "is-valid" ).removeClass( "is-invalid" );
            $( element ).siblings( 'em' ).addClass( "alert alert-danger d-flex align-items-center mt-2" );
   
        },
        unhighlight: function ( element, errorClass, validClass ) {
            $( element ).addClass( "is-valid" ).removeClass( "is-invalid" );
            $( element ).siblings( 'em' ).removeClass( "alert alert-danger d-flex align-items-center mt-2" );
   
        }
   
    });
}


// ----------------------------------------------------------------------------------------------------------------
// Home visit & branch select in step 2
document.addEventListener("DOMContentLoaded", function(event) { 
    document.querySelector('#at-branch-radio').checked = true;
    if (document.querySelector('#at-branch-radio').checked) {
        document.querySelector('#branches-container').style.display = 'block';
        document.querySelector('#branches-header').style.display = 'flex';
        document.querySelector('#home-visit').style.display = 'none';

    } else {
        document.querySelector('#home-visit').style.display = 'block';
        document.querySelector('#branches-container').style.display = 'none';
        document.querySelector('#bbranches-header').style.display = 'none';
        patientAddressValidate();
    }
  });


document.querySelector('#at-branch-radio').addEventListener('change', function () {
    document.querySelector('#branches-container').style.display = 'block';
    document.querySelector('#branches-header').style.display = 'flex';
    document.querySelector('#home-visit').style.display = 'none';
    $("#next").prop( "disabled", false ); 

});
document.querySelector('#home-visit-radio').addEventListener('change', function () {
    document.querySelector('#home-visit').style.display = 'none';
    document.querySelector('#branches-container').style.display = 'block';
    document.querySelector('#branches-header').style.display = 'block';
    //validate on address input
    patientAddressValidate();
    // if(counter == 2){
    //     if($("#patient-home-address").val()==''){
    //         $("#next").prop( "disabled", true );
    //         $("#patient-home-address").keyup(function() {
    //             if($(this).val().length < 6){
    //                // //console.log($(this).val());
    //                 $("#next").prop( "disabled", true );
    //             }
    //             else{
    //                 $("#next").prop( "disabled", false );
    //             }
    //           });
    //     }
    //     else{
    //         $("#next").prop( "disabled", false );
    //     }
    // }
    // else{
    //     $("#next").prop( "disabled", false ); 
    // }
});




// ----------------------------------------------------------------------------------------------------------------
// User select in step 3
// view/hide user cards when radio is changed
// if (document.querySelector('#family-member-radio').checked) {
//     document.querySelector('#user-select').style.display = 'flex';
// } else {
//     document.querySelector('#user-select').style.display = 'none';
// }

document.addEventListener("DOMContentLoaded", function(event) { 
    document.querySelector('#myself-radio').checked = true;
    if (document.querySelector('#myself-radio').checked) {
        document.querySelector('#user-select').style.display = 'none';
        document.querySelector('#myself-select').style.display = 'flex';
    } else {
        document.querySelector('#user-select').style.display = 'flex';
    }
  });


document.querySelector('#family-member-radio').addEventListener('change', function () {
    document.querySelector('#user-select').style.display = 'flex';
    document.querySelector('#myself-select').style.display = 'none';
});
document.querySelector('#myself-radio').addEventListener('change', function () {
    document.querySelector('#user-select').style.display = 'none';
    document.querySelector('#myself-select').style.display = 'flex';

});

// Date picker default value in step 3
    //appear new future dates only
    var todaysDate = new Date();    // Get today's date.
    // Get today's date.
    var year = todaysDate.getFullYear();            // yyyy
    var month = ("0" + (todaysDate.getMonth() + 1)).slice(-2); // mm
    var day = ("0" + (todaysDate.getDate() )).slice(-2);   // dd
    var dtToday = (year + "-" + month + "-" + day); // Results in yyyy-mm-dd
    // //console.log( new Date().toISOString().substring(0, 10));
    // //console.log( dtToday)

    document.getElementById("choose-date").value = dtToday;


    // Now set the max date value for the calendar to be that date.
    $("#step3 #choose-date").attr('min', dtToday);
    var d = new Date();
    d.setDate(d.getDate() + 360); // let user choose time for 12 month 
    // Get today's date.
    var year = d.getFullYear();         // yyyy
    var month = ("0" + (d.getMonth() + 1)).slice(-2); // mm
    var day = ("0" + d.getDate()).slice(-2);    // dd
    var maxDate = (year + '-' + month + '-' + day);
    $("#step3 #choose-date").attr('max', maxDate);


    ////////////////////////////////Step 3
    function getSelectedUser(){
        const user_list = $('#step3 #user-select');
        $(function () {
            // Activate the first user
            function activeFirstUser() {
                $('#step3 #user-select').find('.user').eq(0).addClass('active');
                $('#step3 #user-select').find('.selected-user').eq(0).addClass('active');
            }

            user_list.find('.user').on('click', (e) => {
                const user = $(e.currentTarget);
                const selected_user = $(e.currentTarget).children('.selected-user');
                user_list.find('.user.active').removeClass('active');
                user_list.find('.selected-user.active').removeClass('active');
                user.addClass('active');
                selected_user.addClass('active');
            });
            activeFirstUser();
        });
    }

// ----------------------------------------------------------------------------------------------------------------
// Credit card radio
// document.addEventListener("DOMContentLoaded", function(event) { 
//     document.querySelector('#credit-card-radio').checked = true;
//     if (document.querySelector('#credit-card-radio').checked) {
//         document.querySelector('#credit-card-form').style.display = 'flex';
//         document.querySelector('#credit-card-radio-label').style.color = 'var(--dark-green)';

//     } else {
//         document.querySelector('#credit-card-form').style.display = 'none';
//         document.querySelector('#credit-card-radio-label').style.color = 'var(--gray)';
//     }
// });

// document.querySelector("#credit-card-radio").addEventListener("change", function () {
//     document.querySelector("#credit-card-form").style.display = "block";
//     document.querySelector('#credit-card-radio-label').style.color = 'var(--dark-green)';
//     document.querySelector('#cash-container').style.display = 'none';
//     document.querySelector('#cash-radio-label').style.color = 'var(--gray)';
// });

// Cash radio
// if (document.querySelector('#cash-radio').checked) {
//     document.querySelector('#cash-container').style.display = 'flex';
//     document.querySelector('#cash-radio-label').style.color = 'var(--dark-green)';

// } else {
//     document.querySelector('#cash-container').style.display = 'none';
//     document.querySelector('#cash-radio-label').style.color = 'var(--gray)';
// }

// document.querySelector('#cash-radio').addEventListener('change', function () {
//     document.querySelector('#cash-container').style.display = 'block';
//     document.querySelector('#cash-radio-label').style.color = 'var(--dark-green)';
//     document.querySelector("#credit-card-form").style.display = "none";
//     document.querySelector('#credit-card-radio-label').style.color = 'var(--gray)';
// });

// Loyalty points check
// document.querySelector('#loyalty-points-check').addEventListener('change', function () {
//     if (document.querySelector('#loyalty-points-check').checked) {
//         document.querySelector('#points-container').style.display = 'block';
//         document.querySelector('#loyalty-points-check-label').style.color = 'var(--dark-green)';
//     } else {
//         document.querySelector('#points-container').style.display = 'none';
//         document.querySelector('#loyalty-points-check-label').style.color = 'var(--gray)';
//     }
// });

// Return List of test from Cart
window.onload = function() {
    // Retrieve test lists from local storage

    updateTestListHTML(testList);  
  };
  

  //Remove from cart
  function removeFromCart() {
    $('#testContainer').on('click', '.remove-from-cart', function(e) {
      $("#loading-overlay").show();
      var testId = $(e.currentTarget).attr('data-testId');
  
      // Retrieve testList from local storage
      var testList = JSON.parse(localStorage.getItem('testList'));
  
      // Check if testList exists and is not empty
      if (testList && testList.length > 0) {
        // Find the index of the object with the matching testId
        var index = testList.findIndex(function(item) {
          return item.testId === testId;
        });
  
        // Remove the object from the testList
        if (index > -1) {
            testList.splice(index, 1);
            $("#loading-overlay").hide();
            // Update the testList in local storage
            localStorage.setItem('testList', JSON.stringify(testList));
            updateTestListHTML(testList);

        }
      }
    });
  }
  
  
removeFromCart();

function updateTestListHTML(testList) {
    totalPrice=0;
    // Clear the previous HTML
    $('#testContainer').empty();
    if (testList && testList.length > 0) {
        $('#total-price-container').show();
           // Generate the updated HTML based on the testList
        testList.forEach(function(item) {
            var testHTML = `
            <div class="col-md-6 col-lg-4 mb-3" data-testId="${item.testId}">
            <div class="card h-100">
            <div class="card-body">
                <h5 class="card-title">${item.testName}</h5>
                <hr class="card-separator">
                <div class="card-footer d-flex flex-row align-items-center justify-content-between">
                <div class="price-container">
                    <div class="price">
                    <span class="number">${item.testPrice}</span>
                    <span class="currency">SAR</span>
                    </div>
                </div>
    
                <a style="cursor:pointer;" class="remove-from-cart" data-testId="${item.testId}">
                    <svg class="feather-24">
                    <use href="/dist/img/icon/feather-sprite.svg#trash-2" />
                    </svg>
                </a>
                </div>
            </div>
            </div>
        </div>
            `;
            var testSumarry= `
            <div class="col-md-6 col-lg-4 mb-3"  data-testId="${item.testId}">
            <div class="card h-100">
              <div class="card-body">
                <h5 class="card-title">${item.testName}</h5>
                <hr class="card-separator">
                <div class="card-footer d-flex flex-row align-items-center justify-content-center">
                  <div class="price-container">
                    <div class="price">
                      <span class="number">${item.testPrice}</span>
                      <span class="currency">SAR</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>` 
            totalPrice += parseInt(item.testPrice);
           
            $('#total-price-container').find('.number').text(totalPrice);
            $('#summary-prices').text(testList.length);
            $('#subtotal').text(totalPrice);
            $('#totalamount').text(totalPrice);
            // Append the testHTML to the testContainer
            $('#testContainer').append(testHTML);
            $('#tests-summary').append(testSumarry);

           


        });
       

        $("#next").prop( "disabled", false );
    }
    else{
        totalPrice=0
        $('#total-price-container').hide();
        $('#testContainer').append($(`
        <h5 class="card-title">No Tests at the Cart</h5>
        `));
        $("#next").prop( "disabled", true );

    }
  
 
  }






























  //--------------------------------------- GENERAL METHOD FOR MAKING ORDER [CREATE 0RDER]---------------------------------------------------------------------
// Get User Data for making order request
var orderBranchDetail = {};
var orderHomeVisitDetail = {};
var orderType = true; // To return object of Certain Type
//____________________________________STEP2________________________________________________

// Get BranchId of Default checked Branch

$(document).ready(function () {
    // Get Default Branch Id
    function getDefaultBranchId() {
        var activeSelectedBranch = $('#step2 .branches-wrapper .branch').eq(0).find('.selected-branch').hasClass('active');
        if (activeSelectedBranch) {
            const branchId = $('#step2 .branches-wrapper .branch').eq(0).attr("data-branchid");
            orderBranchDetail.branchId = branchId;
            selectedBranchId=branchId;
            localStorage.setItem('orderBranchDetail', JSON.stringify(orderBranchDetail));
            
        }

        $('#branches_form').find('select').on('change', function (e) {
            activeSelectedBranch = $('#step2 .branch.active').eq(0).find('.selected-branch').hasClass('active');
            if (activeSelectedBranch) {
                 branchId = $('#step2 .branches-wrapper .branch.active').eq(0).attr("data-branchid");
                orderBranchDetail.branchId = branchId;
                selectedBranchId=branchId;
                localStorage.setItem('orderBranchDetail', JSON.stringify(orderBranchDetail));

            }
        });

        // Get BranchId of each clicked Branch
        $('#step2 .branches-wrapper .branch').on('click', function (e) {
            const branchId = $(e.currentTarget).attr("data-branchid");
            orderBranchDetail.branchId = branchId;
            selectedBranchId=branchId;
            localStorage.setItem('orderBranchDetail', JSON.stringify(orderBranchDetail));

        });
   

    }

    // Get Patient Id
    function getPatientId() {
        const patientId = $('#step3 #myself-select #myself-id').attr("data-patientid");
        orderBranchDetail.patientId = patientId;
        orderHomeVisitDetail.patientId = patientId;

        $('#step3 #myself-select #myself-id').on('click', function (e) {
            const patientId = $(e.currentTarget).attr("data-patientid");
            orderBranchDetail.patientId = patientId;
            orderHomeVisitDetail.patientId = patientId;
                // Put the object into storage
            localStorage.setItem('orderBranchDetail', JSON.stringify(orderBranchDetail));
            // Put the object into storage
            localStorage.setItem('orderHomeVisitDetail', JSON.stringify(orderHomeVisitDetail));
        });

        // Put the object into storage
        localStorage.setItem('orderBranchDetail', JSON.stringify(orderBranchDetail));
        // Put the object into storage
        localStorage.setItem('orderHomeVisitDetail', JSON.stringify(orderHomeVisitDetail));
    }

    // Get Family Member Id
    function getFamilyMemberId() {
        var activeSelectedMember = $('#step3 #user-select .family-member-id').eq(0).find('.user.active').hasClass('active');
        if (activeSelectedMember) {
            const familyMemberId = $('#step3 #user-select .family-member-id').eq(0).attr("data-patientid");
            orderBranchDetail.patientId = familyMemberId;
            orderHomeVisitDetail.patientId = familyMemberId;
            localStorage.setItem('orderBranchDetail', JSON.stringify(orderBranchDetail));
            localStorage.setItem('orderHomeVisitDetail', JSON.stringify(orderHomeVisitDetail));
        }

        $('#step3 #user-select .family-member-id').on('click', function (e) {
            const familyMemberId = $(e.currentTarget).attr("data-patientid");
            orderBranchDetail.patientId = familyMemberId;
            orderHomeVisitDetail.patientId = familyMemberId;
            localStorage.setItem('orderBranchDetail', JSON.stringify(orderBranchDetail));
            localStorage.setItem('orderHomeVisitDetail', JSON.stringify(orderHomeVisitDetail));
        });
    }

    // Get Active Id
    function getActiveId() {
        // Default select
        if ($('#myself-radio').prop('checked')) {
            getPatientId();
        } else {
            getFamilyMemberId();
        }

        // On change selection
        $('#step3 #family-member-radio').change(function () {
            getFamilyMemberId();
        });

        $('#step3 #myself-radio').change(function () {
            getPatientId();
        });
    }
    setTimeout(function () {

    // Get BranchId of Default checked Branch
    if ($('#at-branch-radio').prop('checked')) {
        orderType = true;
        orderBranchDetail.notesByPatient='';
        // orderBranchDetail.IsVisit = false;
        getDefaultBranchId();
        getActiveId();
        holder=(new Date());
        holder.setHours(13,57,38,105);
        getSlots(holder.toISOString());
        localStorage.setItem('orderBranchDetail', JSON.stringify(orderBranchDetail));
        orderHomeVisitDetail = {};
        localStorage.setItem('orderHomeVisitDetail', JSON.stringify(orderHomeVisitDetail));
       
    } else {
        getDefaultBranchId();
        orderType = false;
        orderBranchDetail.notesByPatient='';
        // orderHomeVisitDetail.IsVisit = true;
        getActiveId();
        // $('#step3 #date-container').hide();
        orderBranchDetail = {};
        localStorage.setItem('orderBranchDetail', JSON.stringify(orderBranchDetail));
        localStorage.setItem('orderHomeVisitDetail', JSON.stringify(orderHomeVisitDetail));
    }

    // Get object data of create home visit order
    $('#home-visit-radio').change(function () {
        orderType = false;
        orderBranchDetail.notesByPatient='';
        // orderHomeVisitDetail.IsVisit = true;
        getActiveId();
        getDefaultBranchId();
        getSlots(holder);

        $('#patient-home-address').on('input', function () {
            orderHomeVisitDetail.Address = this.value;
        });

        if ($('#patient-home-address').val() !== '') {
            orderHomeVisitDetail.Address = $('#patient-home-address').val();
            // localStorage.setItem('orderHomeVisitDetail', JSON.stringify(orderHomeVisitDetail));
        }

        localStorage.setItem('orderHomeVisitDetail', JSON.stringify(orderHomeVisitDetail));
        // orderBranchDetail = {};
        localStorage.setItem('orderBranchDetail', JSON.stringify(orderBranchDetail));
        // $('#step3 #date-container').hide();
    });

    // Get object data of create branch order
    $('#at-branch-radio').change(function () {
        orderType = true;
        orderBranchDetail.notesByPatient='';
        // orderBranchDetail.IsVisit = false;
        getDefaultBranchId();
        getActiveId();
        localStorage.setItem('orderBranchDetail', JSON.stringify(orderBranchDetail));
        // orderHomeVisitDetail = {};
        localStorage.setItem('orderHomeVisitDetail', JSON.stringify(orderHomeVisitDetail));
        $('#step3 #date-container').show();
    });

    //____________________________________STEP3________________________________________________

    // Get default start date
     defaultDate = $('#step3 #choose-date').val();
      dateformatter = new Date(defaultDate);
      dateformatter.setHours(13, 57, 38, 105);
      holder = dateformatter.toISOString();
      orderBranchDetail.startTime = holder;
      localStorage.setItem('orderBranchDetail', JSON.stringify(orderBranchDetail));


    // deafult end date
    deafultendSlot = $('#choose-time').text();
    dateslot = new Date( holder.split("T")[0]);
    var [hours, minutes] = deafultendSlot.split(":");
    dateslot.setHours(13, 57, 38, 105);

    // Convert the date to ISO string
    const isoFormat = dateslot.toISOString();
    orderBranchDetail.endTime = isoFormat;
    const slotId = $('#step3 #date-dropdown .date-dropdown').attr("data-slotId");
    orderHomeVisitDetail.slotId=slotId;
    localStorage.setItem('orderHomeVisitDetail', JSON.stringify(orderHomeVisitDetail));
    localStorage.setItem('orderBranchDetail', JSON.stringify(orderBranchDetail));

    // Get selected date
    $('#step3 #choose-date').on('change', function () {
        defaultDate= new Date($('#step3 #choose-date').val());
        dateformatter = new Date(defaultDate);
        dateformatter.setHours(13, 57, 38, 105);
        holder = dateformatter.toISOString();
        orderBranchDetail.startTime = holder;
        getSlots(holder);
        localStorage.setItem('orderBranchDetail', JSON.stringify(orderBranchDetail));
    });

    $('#step3 #dropdown').on('click', function () {
        $('#date-dropdown .dropdown-item').on('click', function (e) {
            TimeSlot = $(e.currentTarget).text();
            const slotId = $(e.currentTarget).attr("data-slotId");
            
            $('#choose-time').text(TimeSlot);
            const date = new Date( holder.split("T")[0]);
            const [hours, minutes] = timeSlot.split(":");
            date.setHours(hours, minutes, 0, 0);
            // Convert the date to ISO string
            const isoFormat = date.toISOString();
            orderBranchDetail.endTime = isoFormat;
            orderHomeVisitDetail.slotId=slotId;
            localStorage.setItem('orderBranchDetail', JSON.stringify(orderBranchDetail));
            localStorage.setItem('orderHomeVisitDetail', JSON.stringify(orderHomeVisitDetail));
        });
    });

    //Return testIds
    var testId=JSON.parse(localStorage.getItem('testList'));
    var testLists=[];
    for(let i=0; i<testId.length; i++) {
        testLists.push(testId[i].testId);
    }
    orderBranchDetail.testIds = testLists;
    orderHomeVisitDetail.testIds = testLists;
    orderBranchDetail.testGroupIds=[];
    orderHomeVisitDetail.testGroupIds=[];
    //Retrun paitent Notes and paid amount

    orderHomeVisitDetail.notesByPatient='';
    orderHomeVisitDetail.paidAmount=totalPrice;
    localStorage.setItem('orderHomeVisitDetail', JSON.stringify(orderHomeVisitDetail));
    localStorage.setItem('orderBranchDetail', JSON.stringify(orderBranchDetail));

    // On change Active member selection
    $('#step3 #family-member-radio').change(function () {
        getFamilyMemberId();
    });

    $('#step3 #myself-radio').change(function () {
        getPatientId();
    });
    }, 1000);
});



// $('#next').on('click', (e) => {
//     //console.log("orderType " + orderType);
//     if (orderType == true) {
//         //console.log("branch Order Oject");
//         //console.log(JSON.parse(localStorage.getItem('orderBranchDetail')));
//     }
//     else {
//         //console.log("Home Order Oject");
//         //console.log(JSON.parse(localStorage.getItem('orderHomeVisitDetail')));
//     }

// });

//  Create Order ajax call
function CreateOrder(IsAuthenticated) {
    if (!IsAuthenticated) {
        window.location.href = `${originUrl}/login.html`;

    }
    else {
        if (orderType == true) {
            var orderBranchDetail = JSON.parse(localStorage.getItem('orderBranchDetail'));
            $.ajax({
                type: "POST",
                url:`${Constants.BASE_URL}thirdParty/bookLabAppointment.srvc?method=POST`,
                headers: {
                    'Accept': 'application/json',
                    'Content-Type':'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'Access-Control-Allow-Methods': '*',
                    'Access-Control-Allow-Headers': 'Content-Type , Authorization',
                    'Access-Control-Allow-Credentials': 'true',
                    'Authorization': `Bearer ${TPP_Token.Token}`
                },
                data:JSON.stringify(orderBranchDetail),
                success: function (data) {
                  $("#loading-overlay").hide();
                   setTimeout(function () {
                    $("#loading-overlay").show();
                    $("#successAlert").text("Order successfully Compeleted")
                    $("#sucessOrder").show();
                    window.location.href = `${originUrl}/account.html#profile`;
                    localStorage.removeItem('orderBranchDetail');
                    localStorage.removeItem('testList');

                }, 3000);
                
        
                },
                
                });
            }
        else {
            var orderHomeVisitDetail = JSON.parse(localStorage.getItem('orderHomeVisitDetail'));
            $.ajax({
                type: "POST",
                url:`${Constants.BASE_URL}thirdParty/bookHomeAppointment.srvc?method=POST`,
                headers: {
                    'Accept': 'application/json',
                    'Content-Type':'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'Access-Control-Allow-Methods': '*',
                    'Access-Control-Allow-Headers': 'Content-Type , Authorization',
                    'Access-Control-Allow-Credentials': 'true',
                    'Authorization': `Bearer ${TP_Token.Token}`
                },
                data:JSON.stringify(orderHomeVisitDetail),
                success: function (data) {
                  $("#loading-overlay").hide();
                   setTimeout(function () {
                    $("#loading-overlay").show();
                    $("#successAlert").text("Order successfully Compeleted")
                    $("#sucessOrder").show();
                    window.location.href = `${originUrl}/account.html#profile`;
                    localStorage.removeItem('orderHomeVisitDetail');
                    localStorage.removeItem('testList');

                }, 3000);
                
        
                },
                
                });
        }
    }
}
//--------------------------------------- GENERAL METHOD FOR MAKING ORDER [EDIT CREATED 0RDER]---------------------------------------------------------------------


// Handle Translation 

function getLanguageFromLocalStorage() {
    // Retrieve the language value from localStorage
    const language = localStorage.getItem('i18n');
  
    // Default language if not found in localStorage
    const defaultLanguage = 'en_us';
  
    // Return the corresponding key based on the language value
    switch (language) {
      case 'ar':
        return 'ar_jo';
      case 'en':
        return 'en_us';  
      // Add more cases for other languages if needed
      default:
        return defaultLanguage;
    }
  }